import React from 'react';
import DashboardListIcons from '../Dashboard/DashboarListIcon/DashboardListIcons';
import TopNav from '../Dashboard/Top-Nav/TopNav';
import OrganizationListing from './OrganizationListing';
import Layout from '../layout/Layout';

const Organization = () => {
  return (
    <Layout heading={'Organization'}>
      <OrganizationListing />
    </Layout>
  );
};

export default Organization;
